import React from 'react';
import Banner from "@components/Banner/Banner";
// import Cards from "@components/Cards";
import Text from "@components/RTE/Text";
import Container from "@components/Container";
import Quote from "@components/Quote/Quote";
import RequestARepresentativeForm from "@components/Form/ConnectForm";
import SurgeonSelector from "@components/Form/SurgeonSelector";
import MedicalInquiryForm from "@components/Form/MedicalInquiryForm";
import CardsAssembly from "@components/CardsAssembly";
import Image from "@components/Image";
import PageNavigation from "@components/PageNavigation";
import Cta from "@components/CTA";
import Table from "@components/Table/Table";
import Hotspot from "@components/Hotspot/Hotspot";
import ResourceBlock from "@components/ResourcesBlock";
import Video from "@components/Video/Video";


 // Recursive function to handle nested content
 const MapTo = (props) => {
     if (!props) return null;
     
     const renderContent = (item) => { 
         
		 switch (item.__typename) {
			 case "ContentfulBanner":
				 return <Banner key={item.id} content={item} />;
              
            case "ContentfulRichText":
              return (
                  <Text key={item.id}
					  content={item?.text?.raw ? JSON.parse(item?.text?.raw) : null}
                      marginTopDesktop={item.marginTopDesktop}
                      marginTopMobile={item.marginTopMobile}
                      marginBottomDesktop={item.marginBottomDesktop}
                      marginBottomMobile={item.marginBottomMobile}
                      paddingTopDesktop={item.paddingTopDesktop}
                      paddingTopMobile={item.paddingTopMobile}
                      paddingBottomDesktop={item.paddingBottomDesktop}
                      paddingBottomMobile={item.paddingBottomMobile}
                      maxWidthDesktop={item.maxWidthDesktop}
                      maxWidthMobile={item.maxWidthMobile}	
                      marginLeftDesktop={item.marginLeftDesktop}
                      marginLeftMobile={item.marginLeftMobile}
                      marginRightDesktop={item.marginRightDesktop}
                      marginRightMobile={item.marginRightMobile}
                      paddingLeftDesktop={item.paddingLeftDesktop}
                      paddingLeftMobile={item.paddingLeftMobile}
                      paddingRightDesktop={item.paddingRightDesktop}
                      paddingRightMobile={item.paddingRightMobile}
                      entryTitle={item.entryTitle}
                      classOverlay={item?.classOverlay?.classOverlay}
                      textColor={item.textColor?.textColor}
					  textAlign={item.textAlign}
					  nodeStyles={item.nodeStyles}
					  className={props.className}
                  />
              );
      
			case "ContentfulTable":
				return (
					<Table
						key={item.id}
						content={item || null}
						tableType={item.type}
					/>
				);

            case "ContentfulContainer":
              return (
                  <Container key={item.id} 
					  backgroundImage={item.backgroundImage}
					  backgroundImageMobile={item.backgroundImageMobile}
                    backgroundColor={item.backgroundColor} 
                    marginTopDesktop={item.marginTopDesktop} 
                    marginTopMobile={item.marginTopMobile} 
                    marginBottomDesktop={item.marginBottomDesktop} 
                    marginBottomMobile={item.marginBottomMobile} 
                    paddingTopDesktop={item.paddingTopDesktop} 
                    paddingTopMobile={item.paddingTopMobile} 
                    paddingBottomDesktop={item.paddingBottomDesktop} 
                    paddingBottomMobile={item.paddingBottomMobile} 
                    maxWidthDesktop={item.maxWidthDesktop} 
                    maxWidthMobile={item.maxWidthMobile} 
                    marginLeftDesktop={item.marginLeftDesktop} 
                    marginLeftMobile={item.marginLeftMobile} 
                    marginRightDesktop={item.marginRightDesktop} 
                    marginRightMobile={item.marginRightMobile} 
                    paddingLeftDesktop={item.paddingLeftDesktop} 
                    paddingLeftMobile={item.paddingLeftMobile} 
                    paddingRightDesktop={item.paddingRightDesktop} 
                  paddingRightMobile={item.paddingRightMobile} 
                  borderRadiusTop={item.borderRadiusTop}
                  borderRadiusBottom={item.borderRadiusBottom}
                  entryTitle={item.entryTitle} 
                  classOverlay={item?.classOverlay?.classOverlay}
					  borderRadius={item?.borderRadius}
					  contentfulid={item.contentfulid}
					  type={item.type}
					  items={item.items}
					  visibility={item.visibility}
					  boxShadow={item.boxShadow}
				  >
                  {item.items && item.items.map(nestedItem => renderContent(nestedItem))}
                </Container>
			  );
              
			case "ContentfulQuote":
				return (
					<Quote
						content={item.items}
						type={item.type}
						style={``}
					/>
				);

			case "ContentfulExparelForms":
				 return (
					 item.type === "Exparel Pro - Connect" ? (
						<RequestARepresentativeForm 
							successBlock={item.successBlock} formIntroductionHeader={item.formIntroductionHeader} formIntroductionFooter={item.formIntroductionFooter}/>
					 ) : item.type === "Exparel Pro - Medical Inquiry" ? (
						 <MedicalInquiryForm successBlock={item.successBlock} formIntroductionHeader={item.formIntroductionHeader} formIntroductionFooter={item.formIntroductionFooter} />
					 ) : item.type === "Exparel Pro - Surgeon Selector" ? (
						 <SurgeonSelector successBlock={item.successBlock} formIntroductionHeader={item.formIntroductionHeader} formIntroductionFooter={item.formIntroductionFooter} />
					 ) : null
				);

			case "ContentfulCardAssembly":
				return (
					<CardsAssembly
						content={item}
					/>
				);

			case "ContentfulMedia":
				if (item.hotspots?.hotspots?.hotspots) {
					return (
						<Hotspot hotspotContent={item.hotspots?.hotspotContent} hotspots={item.hotspots?.hotspots?.hotspots} {...props} src={item?.asset?.file?.url}
						srcMobile={item?.assetMobile?.file?.url} alt={item.altText} altMobile={item.altText}/>
					);
				}
				else {
					if (item?.asset?.file?.url) {
						return (
							<Image
								src={item?.asset?.file?.url}
								srcMobile={item?.assetMobile?.file?.url}
								alt={item.altText}
								altMobile={item.altText}
								className={props.className}
								pictureClassName={props.pictureClassName}
							/>
						);
					} else {
						return null;
					}
				}

			case "ContentfulPageNavigation":
				return (
					<PageNavigation
						content={item}
					/>
				);

			case "ContentfulLink":
				return (
					<Cta
						displayType={item.displayType}
						label={item.label}
						href={item.href}
						target={item.target}
						disabled={item.disabled}
						style={item.style}
						theme={item.theme}
					/>
				);

			 case "ContentfulVideo":
				 return (
					 <Video
						 videoId={item.videoId}
						 videoHash={item.videoHash}
						 videoTitle={item.videoTitle}
						 autoplay={item.autoplay}
						 playerType={item.playerType}
						 backgroundColor={item.backgroundColor}
						 playMethod={item.playMethod}
						 className={props.className}
						 thumbnail={item.thumbnail}
					 />
				 );

			 case "ResourceBlock":
				 return (
					 <ResourceBlock
						 content={item}
					 />
				);

            default:
              console.warn(`Unknown content type: ${item.__typename}`);
              return null;
          }
     }
    
	 if (props.items) {
		 return renderContent(props.items);
	 } else if (props.__typename) {
		 return renderContent(props);
	 }
  };

export default MapTo;